import { type FC } from 'react';

import type { PublicTemporaryMessage } from '@api-client/temporary-messages';
import { useIsOpen } from '@luna/utils-ui';

import { TemporaryMessagesHeader } from './TemporaryMessagesHeader';
import { TemporaryMessageModal } from './TemporaryMessageModal';
import { trackTemporaryMessageSelected } from './TemporaryMessageTrackingService';

interface Props {
    message: PublicTemporaryMessage;
    onMessageClose(messageId: string): void;
    trigger: string | undefined;
}

export const TemporaryMessage: FC<Props> = ({ message, onMessageClose, trigger }) => {
    const [isMessageModalOpen, openMessageModal, closeMessageModal] = useIsOpen(false);

    const onMessageDetailModalOpen = () => {
        trackTemporaryMessageSelected(message, trigger);
        openMessageModal();
    };

    return (
        <>
            <div className="w-100">
                <TemporaryMessagesHeader
                    message={message}
                    onClose={onMessageClose}
                    openDetail={onMessageDetailModalOpen}
                    trigger={trigger}
                />
            </div>
            <TemporaryMessageModal
                isOpen={isMessageModalOpen}
                title={message.localizedText.title}
                text={message.localizedText.body}
                onClose={closeMessageModal}
                severity={message.severity}
            />
        </>
    );
};
